// Conversion d'unités du référentiel Inter-arrêts.
// Backend : distance_meters (int) / travel_time_seconds (int) — UI : km / min.

export function formatKm(meters) {
  if (meters == null || Number.isNaN(Number(meters))) return "—";
  const km = Number(meters) / 1000;
  return `${km.toLocaleString("fr-CH", { minimumFractionDigits: 1, maximumFractionDigits: 1 })} km`;
}

export function formatMinutes(seconds) {
  if (seconds == null || Number.isNaN(Number(seconds))) return "—";
  return `${Math.round(Number(seconds) / 60)} min`;
}

export function kmToMeters(kmStr) {
  const v = parseFloat(String(kmStr).replace(",", "."));
  if (Number.isNaN(v) || v < 0) return null;
  return Math.round(v * 1000);
}

export function minutesToSeconds(minStr) {
  const v = parseFloat(String(minStr).replace(",", "."));
  if (Number.isNaN(v) || v < 0) return null;
  return Math.round(v * 60);
}

export function metersToKmInput(meters) {
  return meters == null ? "" : String(Math.round(meters / 100) / 10);
}

export function secondsToMinInput(seconds) {
  return seconds == null ? "" : String(Math.round(seconds / 60));
}

export function formatCoord(v) {
  return v == null ? "—" : Number(v).toFixed(5);
}
